import { Clock, Users, Heart, Vegan, Ban, Beef, FishIcon, Eye } from 'lucide-react';
import { Utensils, Soup, Pizza, Fish, Egg, Flame, Leaf, Drumstick, CakeSlice, Salad, LucideMilkOff, LucideWheatOff, LucideNutOff } from 'lucide-react';

export const cuisineIcons: Record<string, JSX.Element> = {
  Italian: <Pizza size={14} className="mr-1" />,
  Nigerian: <Drumstick size={14} className="mr-1" />,
  Chinese: <Soup size={14} className="mr-1" />,
  Seafood: <Fish size={14} className="mr-1" />,
  Veggie: <Leaf size={14} className="mr-1" />,
  Vegan: <Vegan size={14} className="mr-1" />,
  Dessert: <CakeSlice size={14} className="mr-1" />,
  Spicy: <Flame size={14} className="mr-1" />,
  "Low Calorie": <div className="w-[14px] h-[14px] rounded-full border border-gray-200 flex items-center justify-center text-[7px] font-bold text-white mr-1"> LC</div>,
  "High Protein": <Drumstick size={14} className="mr-1" />,
  "Quick Meal": <Egg size={14} className="mr-1" />,
  "Family Meal": <Utensils size={14} className="mr-1" />,
  "Comfort Food": <Soup size={14} className="mr-1" />,
  "Meal Prep": <Drumstick size={14} className="mr-1" />,
  "On the Go": <Egg size={14} className="mr-1" />,
  "Weekend Special": <CakeSlice size={14} className="mr-1" />,
  "Holiday Feast": <Utensils size={14} className="mr-1" />,
  "Brunch": <Egg size={14} className="mr-1" />,
  "Comfort": <Soup size={14} className="mr-1" />,
  "Quick": <Egg size={14} className="mr-1" />,
  "Family": <Utensils size={14} className="mr-1" />,
  "Vegetarian": <Leaf size={14} className="mr-1" />,
  "Gluten Free": <LucideWheatOff size={14} className="mr-1" />,
  "Low Carb": <Drumstick size={14} className="mr-1" />,
  "High Fiber": <Salad size={14} className="mr-1" />,
  "Low Fat": <Drumstick size={14} className="mr-1" />,
  "Low Sugar": <CakeSlice size={14} className="mr-1" />,
  "High Energy": <Flame size={14} className="mr-1" />,
  "Weekend": <CakeSlice size={14} className="mr-1" />,
  "Holiday": <Utensils size={14} className="mr-1" />,
  "Nut Free": <LucideNutOff size={14} className="mr-1" />,
  'Dairy Free': <LucideMilkOff size={14} className="mr-1" />,
  'Red Meat': <Beef size={14} className="mr-1" />,
  'White Meat': <Drumstick size={14} className="mr-1" />,
  'Fish & Seafood': <FishIcon size={14} className="mr-1" />,
  'Fish &amp; Seafood': <FishIcon size={14} className="mr-1" />,
  Breakfast: <Egg size={14} className="mr-1" />,
  Healthy: <Salad size={14} className="mr-1" />,
  Default: <Utensils size={14} className="mr-1" />
};

export const tagColor = (tag: string): string => {
  switch (tag) {
    case 'Vegetarian':
    case 'Vegan':
      return 'bg-brand-teal/90 text-white';
    case 'Veggie':
      return 'bg-brand-green text-white';
    case 'White Meat':
      return 'bg-brand-pink text-white';
    case 'Red Meat':
      return 'bg-brand-red text-white';
    case 'Fish & Seafood':
    case 'Fish &amp; Seafood':
      return 'bg-brand-cyan/90 text-white';



    case 'Gluten Free':
      return 'bg-orange-400 text-white';
    case 'Dairy Free':
      return 'bg-brand-blue text-white';
    case 'Low Calorie':
      return 'bg-brand-yellow/80 text-white';
    case 'Nut Free':
      return 'bg-brand-purple/80 text-white';



    case 'Breakfast':
    case 'Spicy':
    case 'High Energy':
      return 'bg-brand-red text-white';
    case 'Dessert':
    case 'Weekend Special':
    case 'Weekend':
    case 'Brunch':
      return 'bg-brand-pink text-white';
    case 'Seafood':
    case 'Low Fat':
    case 'Low Sugar':
      return 'bg-brand-blue text-white';
    case 'High Protein':
    case 'Meal Prep':
    case 'Quick Meal':
    case 'On the Go':
    case 'Quick':
      return 'bg-brand-yellow text-white';
    case 'Family Meal':
    case 'Family':
    case 'Holiday':
    case 'Holiday Feast':
      return 'bg-brand-purple text-white';
    case 'Comfort Food':
    case 'Comfort':
      return 'bg-orange-500 text-white';



    case 'Italian':
      return 'bg-brand-green text-white';
    case 'Chinese':
    case 'Asian':
      return 'bg-brand-indigo text-white';
    case 'Mexican':
      return 'bg-brand-yellow text-white';
    case 'European':
      return 'bg-brand-purple text-white';
    case 'British':
      return 'bg-brand-cyan text-white';

    default:
      return 'bg-white/90 dark:bg-gray-800/90 text-gray-800 dark:text-gray-200';
  }
};

export const cuisineFlags: Record<string, string> = {
  // Regional cuisines
  "Asian": "🇨🇳🇯🇵",
  "African": "🇳🇬🇪🇹",
  "European": "🇪🇺",
  "North American": "🌎",
  "South American": "🌎",
  "Middle Eastern": "🇱🇧🇸🇦",
  "Caribbean": "🏝️",
  "Mediterranean": "🌊",
  "Latin American": "🌎",

  // Specific cuisines
  "American": "🇺🇸",
  "British": "🇬🇧",
  "Chinese": "🇨🇳",
  "French": "🇫🇷",
  "German": "🇩🇪",
  "Greek": "🇬🇷",
  "Indian": "🇮🇳",
  "Italian": "🇮🇹",
  "Japanese": "🇯🇵",
  "Korean": "🇰🇷",
  "Mexican": "🇲🇽",
  "Moroccan": "🇲🇦",
  "Nigerian": "🇳🇬",
  "South African": "🇿🇦",
  "Spanish": "🇪🇸",
  "Thai": "🇹🇭",
  "Turkish": "🇹🇷",
  "Vietnamese": "🇻🇳",
  "Brazilian": "🇧🇷",
  "Lebanese": "🇱🇧",
  "Ethiopian": "🇪🇹",
  "Russian": "🇷🇺",
  "Canadian": "🇨🇦",
  "Indonesian": "🇮🇩",
  "Filipino": "🇵🇭",
  "Peruvian": "🇵🇪",
  "Argentinian": "🇦🇷",
  "Cuban": "🇨🇺",
  "Malaysian": "🇲🇾",

  // Fallback
  "Default": "🍽️"
};